<template>
  <div class="patient_page w3-container">
    <div>
      <p class="w3-bar">{{"Patient Page"}}</p>
    </div>
    <patient-card v-bind:patientData="findPatientById(patient_id)"/>
    <folding-container v-if="isPrivilegedUser" v-bind:labelText="'პაცინეტის მონაცემების ჩასწორება'">
      <div class="w3-card">
        <edit-patient v-bind:patientData="findPatientById(patient_id)"/>
      </div>
    </folding-container>
    <test-pack-selector v-if="isPrivilegedUser" v-bind:patientId="patient_id"/>
    <div>
      <h3>ტესტები</h3>
      <div class="w3-bar w3-teal">
        <button class="w3-bar-item w3-button" @click="activateTab('default')">Tests</button>
        <button class="w3-bar-item w3-button" @click="activateTab('covid')">Covid</button>
      </div>
      <div class="w3-animate-left" v-show="tab.activeTab === 'default'">
        <test-card v-for="(test, index) in test_data_sorted" :key="'test-card'+index" :testDatum="test"></test-card>
      </div>
      <div class="w3-animate-left" v-show="tab.activeTab === 'covid'">
        covid tests
        <covid-test-card v-for="cTest in covid_test_data" v-bind:key="cTest.test_id" v-bind:test_json="cTest"/>

      </div>
    </div >
    <!-- <p class="w3-tiny w3-teal" v-if="test_data != null">{{test_data}}</p> -->
    <!-- <div>
      TODO: ამოსაჩლელი დროებით
      <edit-test v-bind:testDef="getTestDefById('1')" v-bind:prefillData="[1, '5']"/>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import TestCard from "../components/TestCard.vue";
import PatientCard from "../components/PatientCard.vue";
import EditPatient from "../components/EditPatient.vue";
import FoldingContainer from "../components/containers/FoldingContainer.vue";
import EditTestVue from "../components/EditTest.vue";
import TestPackSelectorVue from '../components/TestPackSelector.vue';
import { setTimeout } from 'timers';
import CovidTestCardVue from '../components/CovidTestCard.vue';
var api_path = "/php_scripts/";
if (process.env.NODE_ENV === "development") {
  api_path = "http://localhost/php_scripts/";
}
export default {
  name: "PatientPage",
  props: ["patient_id"],
  data() {
    return {
      loading: false,
      test_data: null,
      test_data_sorted: null,
      covid_test_data: [],
      error: null,
      tab: {
        activeTab: 'default',
      }
    };
  },
  components: {
    "test-card": TestCard,
    "patient-card": PatientCard,
    "edit-patient": EditPatient,
    "folding-container": FoldingContainer,
    "edit-test": EditTestVue,
    "test-pack-selector": TestPackSelectorVue,
    "covid-test-card": CovidTestCardVue,
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters({findPatientById:"findPatientById", getTestDefById:"getTestDefById", isPrivilegedUser:"getIsprivilegedUser"})
    // ...mapState(["patientList"])
    // patient: this.$store.getPatientByIndex[index]
  },
  methods: {
    sortTestData(data, sort_param, direction = -1) {
      delete data.error;
      return Object.values(data).sort(function(a, b) {
        let a_date = Date.parse(a.test_date),
          b_date = Date.parse(b.test_date);
        // console.log(a_date, b_date);
        // return a > b;
        return direction * (a_date - b_date);
      });
    },
    fetchData() {
      this.error = this.post = null;
      this.loading = true;
      axios
        .get(api_path + "get_test_data_by_patient_id_json.php", {
          params: {
            patient_id: this.patient_id
          }
        })
        .then((response) => {
          this.test_data = response.data;
          this.test_data_sorted = this.sortTestData(
            response.data,
            "default"
          );
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(api_path + 'get_covit_test_by_patient_id.php', {
          params: {
            patient_id: this.patient_id
          }
        })
        .then((response) => {
          console.log(response)
          this.covid_test_data = response.data.map( test_item => {
            return {
              patient_id: test_item.patient_id,
              test_id: test_item.test_id,
              covid_data: JSON.parse(test_item.covid_data),
            }
          })
          
          console.log(this.covid_test_data);
          // this.covid_test_data.covid_data = JSON.parse(this.covid_test_data.covid_data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    activateTab(tabName) {
      this.tab.activeTab = tabName
    }
  }
};
</script>

<style scoped>
</style>
